import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Utymd } from '../entity/Utymd-angular';


@Injectable({
  providedIn: 'root'
})
export class UtymdServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = 'MD001=MC001,MD002=MC002,MD011=MC020';
    this.defaultItem = new Utymd();
    this.entityType.type = EntityType.detail;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MD001: '編號', MD002: '流水號', MD003: '序號', MD004: '類別', MD005: '備註', MD006: '帳號', MD007: '密碼', MD008: '日期', MD009: '網址', MD010: '資料', MD011: 'customId'
    };

    this.fieldNames = 'MD001,MD002,MD003,MD004,MD005,MD006,MD007,MD008,MD009,MD010,MD011';
    this.fieldLengths = { MD001: 15, MD002: 6, MD003: 4, MD004: 20, MD005: 255, MD006: 50, MD007: 50, MD008: 8, MD009: 500, MD010: 2000, MD011: 10 };
    this.columnDefs = [
      { field: "MD003", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "MD004", headerName: "類別", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MD006", headerName: "帳號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MD007", headerName: "密碼", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MD008", headerName: "日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "MD009", headerName: "網址", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MD010", headerName: "資料", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MD005", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MD002", headerName: "流水號", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MD011", headerName: "customId", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MD001", headerName: "編號", headerTooltip: "", width: 190, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'UTYMD';
    this.isSys = false;
    this.sqlSelect = `SELECT *  FROM UTYMD`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MD001,MD002,MD011,MD003`;
    this.keyFields = ['MD001', 'MD002', 'MD003', 'MD011'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MD001', 'MD002', 'MD003', 'MD011'];
    this.seqField = 'MD003';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Utymd): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Utymd): Promise<Utymd> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
